import { useIntl } from 'react-intl';

import useTimeFormat from 'hooks/useTimeFormat';

import tcDashboardTableConfig from './TCDashboardTableConfig';

import { TCDashboardTableProps } from './types';

import * as S from './styles';

const TCDashboardTable: React.FC<TCDashboardTableProps> = ({
  loading,
  filterType,
  patientsInfo,
  showActivitiesByGeoCode,
}) => {
  const intl = useIntl();
  const { getRelativeTime, formatToDayAndMonth } = useTimeFormat();

  const { columnsFilterTypes } = tcDashboardTableConfig({
    formatToDayAndMonth,
    getRelativeTime,
    intl,
    showActivitiesByGeoCode,
  });

  let columnFilterType = columnsFilterTypes[filterType] || [];

  // TODO: Remove this filter after discharge_reason property backend deploy
  if (
    patientsInfo &&
    columnFilterType.length &&
    filterType === 'unlinked_users' &&
    patientsInfo[0].dischargeReason === undefined
  ) {
    columnFilterType = columnFilterType.filter(
      column => column.key !== 'enduser_dischargeReason',
    );
  }

  const linkReasonMap = {
    user_discharged_by_cx: 'CXUNLINK',
    user_discharged_by_cp: 'CLINICALDISCHARGE',
    user_transferred_by_tc: 'USER_TRANSFERRED_BY_TC', // TODO: Ask Jessica about this translation key
    user_selected_TC_journey: 'WELLZSPECIALIST',
    user_selected_tc_journey: 'WELLZSPECIALIST',
    user_unlinked_by_cp_layoff: 'PSYCHOLOGISTLAYOFF',
    user_did_not_selected_journey: 'NOCHOICE',
    user_selected_cp_journey_no_booked_session: 'PSYCHOLOGIST',
    user_not_satisfied_with_cp_suggestions: 'SUPPORTCHOOSE',
    user_potentially_critical_not_satisfied_with_cp_suggestions:
      'POTENTIALCRITICAL',
    user_with_accesssibility_needs: 'ACCESSIBILITY',
    user_sent_message_tc_auto_journey: 'TCAUTOJOURNEYSENDMESSAGE',
    user_did_not_send_message_tc_auto_journey: 'TCAUTOJOURNEYNOMESSAGE',
    user_sent_message_tc_journey: 'TCJOURNEYSENDMESSAGE',
    user_did_not_send_message_tc_journey: 'TCJOURNEYNOMESSAGE',
  };

  const dischargeReasonMap = {
    new_link: 'THERAPY',
    inactive: 'INACTIVITY',
    eligibility_shutdown: 'NOTELIGIBLE',
    company_shutdown: 'INELIGIBLECOMPANY',
    user_deleted: 'DELETEDACCOUNT',
    forward: 'REFERRAL', // TODO: BE don't send this discharge reason yet
  };

  const patientsInfoTranslated = patientsInfo?.map(patientInfo => {
    if (patientInfo.reason) {
      return {
        ...patientInfo,
        translatedReason: intl.formatMessage({
          id: `DASHBOARD.TC.COLUMN.${linkReasonMap[patientInfo.reason]}`,
          defaultMessage: '-',
        }),
      };
    }
    if (patientInfo.dischargeReason !== undefined) {
      return {
        ...patientInfo,
        dischargeReason: intl.formatMessage({
          id: `DASHBOARD.TC.COLUMN.${
            dischargeReasonMap[patientInfo.dischargeReason]
          }`,
          defaultMessage: '-',
        }),
      };
    }
    return patientInfo;
  });

  const nameColumnWidth = columnFilterType?.find(
    column => column.dataKey === 'fullName',
  )?.width;

  const hasActionButton = !!columnFilterType?.find(
    column => column.dataKey === 'actions',
  );

  const columnFilterTypeLength = columnFilterType?.length;

  // Name column and Action Column have fixed width so do not count to the quantity;
  const columnsQuantity = hasActionButton
    ? columnFilterTypeLength - 2
    : columnFilterTypeLength - 1;

  return (
    <S.Container>
      <S.StyledTable
        fixedHeader
        loading={loading}
        sortDefault={false}
        loadingStyle="LinesSmall"
        columns={columnFilterType}
        data={patientsInfoTranslated}
        nameColumnWidth={nameColumnWidth}
        hasActionColumn={hasActionButton}
        columnsQuantity={columnsQuantity}
      />
    </S.Container>
  );
};

export default TCDashboardTable;
